export const SET_URL_FILTERS = 'URLFILTERS/SET';
export const UPDATE_URLFILTERS = 'URLFILTERS/LOAD';
